import axios from 'axios';
import qs from 'qs';
import {compress} from "./util/pako";

const debugService = axios.create({
  baseURL: process.env.REACT_APP_GW_URL+'/pytutor/',
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true
});
const pyTutorService = axios.create({
  baseURL: process.env.REACT_APP_GWE_URL+'/pytutor/',
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true
});
const getPath = (lang) => {
  switch (lang) {
    case 'python':
    case 'python3':
      return 'web_exec_py3.py';
    case 'c':
      return 'web_exec_c.py';
    case 'cpp':
      return 'web_exec_cpp.py';
    case 'java':
      return 'web_exec_java.py';
    case 'javascript':
      return 'web_exec_js.py';
    default:
      return 'web_exec_py3.py';
  }
};
/**
 * 获取调试追踪信息
 */
const getDebugTrace = async (lang, user_script) => {
  const options = {
    "cumulative_mode": false,
    "heap_primitives": false,
    "show_only_outputs": false,
    "origin": "opt-frontend.js",
    "cpp_version": "cpp_g++9.3.0",
    "fe_disableHeapNesting": true,
    "fe_textualMemoryLabels": false
  }

  if (lang === 'c'){
    options.cpp_version = "c_gcc9.3.0"
  }

  const handlePath = getPath(lang);
  let service = pyTutorService;
  if (handlePath === 'web_exec_py3.py'){
    service = debugService;
    try {
      const body = {
        user_script,
        options_json: options
      }
      const encodedBody = compress(JSON.stringify(body));
      console.log("encodedBody", encodedBody);
      const response = await service.post(handlePath, encodedBody,{
        headers: {
          'EncodeScheme' : 'PAKO'
        },
        transformRequest: [(data) => data]  // 阻止 axios 包裹双引号
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }else{
    try {
      const response = await service.get(handlePath, {
        params: {
          user_script,
          // options_json: '{"cumulative_mode":false,"heap_primitives":false,"show_only_outputs":false,"origin":"opt-frontend.js"}'
          options_json: JSON.stringify(options)

        } ,
        paramsSerializer: (params) =>
          qs.stringify(params, { encode: true, format: 'RFC3986' }) // 强制使用 RFC3986 标准（空格转为 `%20`）
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

};

/**
 * 获取调试追踪信息
 */
const getPyTutorTrace = async (user_script) => {
  try {
    const response = await pyTutorService.get('web_exec_c.py', {
      params: {
        user_script: user_script,
        options_json: '{"cumulative_mode": false,"heap_primitives": false,"show_only_outputs": false,"origin": "opt-frontend.js","cpp_version": "c_gcc9.3.0","fe_disableHeapNesting": true,"fe_textualMemoryLabels": false}'
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: true, format: 'RFC3986' }) // 强制使用 RFC3986 标准（空格转为 `%20`）
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { getDebugTrace, getPyTutorTrace };
